import { ref } from 'vue';

const isSettingProject = ref(true);
// 최초 true -> 메뉴 보임

export function useProjectSetting() {
  const toggleSetting = () => {
    isSettingProject.value = !isSettingProject.value;
    handleSettingProject();
  }

  const handleSettingProject = () => {
    const settingMenu = document.querySelector('.setting-page__menu') as HTMLElement;
    if (!settingMenu) {
      return;
    }
    if (isSettingProject.value) {
        settingMenu.style.display = '';
        setTimeout(() => {
            settingMenu.style.top = '0rem';
        }, 200);
        } else {
        settingMenu.style.top = '-100%';
        setTimeout(() => {
            settingMenu.style.display = 'none';
        }, 500);
    }
  }

  return {
    isSettingProject,
    toggleSetting,
    handleSettingProject,
  };
}
